import type { NominatimResult } from "../types";

const NOMINATIM_BASE_URL = "https://nominatim.openstreetmap.org";

export const searchAddress = async (
	query: string,
	limit = 5
): Promise<NominatimResult[]> => {
	const response = await fetch(
		`${NOMINATIM_BASE_URL}/search?format=json&q=${encodeURIComponent(query)}&countrycodes=br&limit=${limit}`
	);

	if (!response.ok) {
		throw new Error("Failed to fetch address");
	}

	return response.json();
};

export const reverseGeocode = async (
	latitude: string,
	longitude: string
): Promise<string> => {
	try {
		const response = await fetch(
			`${NOMINATIM_BASE_URL}/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
		);

		if (!response.ok) {
			throw new Error("Failed to fetch address");
		}

		const data = await response.json();
		return data.display_name || "Endereço não encontrado";
	} catch {
		return "Erro ao buscar endereço";
	}
};
